export default {
  basp: {
    orderNumber: 'Nomor Pesanan',
    customer: 'Nama Shipper',
    transporter: '3PL',
    baspNote: 'Keterangan BASP',
    shipmentGroupNo: 'Nomor Shipment',
    orderDate: 'Tanggal Pesanan',
    pickupDate: 'Tanggal Pickup',
    podDate: 'Tanggal POD',
    shipmentStatus: 'Status Pengiriman',
    baspReason: 'Alasan Selisih',
    itemNote: 'Keterangan Item',
    shipperAction: 'Action Plan Shipper',
    inputOrderNumber: 'Masukkan Nomor Pesanan',
  },
  customer: {
    name: 'Nama Customer',
    pic: 'Penanggung Jawab (PIC)',
    address: 'Alamat',
    phone: 'Nomor Telepon',
    originLocation: 'Lokasi Asal',
    destinationLocation: 'Lokasi Tujuan',
    contractDate: 'Tanggal Kontrak',
    inputCustomerName: 'Masukkan Nama Customer',
  },
  rating: {
    nameTransporter: 'Nama Transporter',
    averageRating: 'Rata - Rata Rating',
    inputTransporterName: 'Masukkan Nama Transporter',
    vehicleName: 'Nama Kendaraan',
    vehiclePlat: 'Plat Nomor Kendaraan',
    vehicleRating: 'Rating Kendaraan',
    driverName: 'Nama Sopir',
    driverPhone: 'Nomor Telepon',
    driverRating: 'Rating Sopir',
    inputVehiclePlat: 'Masukkan Plat Nomor Kendaraan',
    inputDriverName: 'Masukkan Nama Sopir',
    orderRating: 'Rating Pesanan',
  },
  footer: {
    listTransporter: 'Daftar Transporter',
    listVehicle: 'Daftar Kendaraan',
    listOrder: 'Daftar Pesanan'
  }
}
